import React from "react";
import { Box, TableCell, TableRow } from "@mui/material";

/**
 * The loading state for a table.
 *
 * The book is explicit that a table never gets a spinner. A spinner only says
 * "wait"; a skeleton says what is arriving and how much of it there is, so the
 * page does not jump when the rows land and the eye already knows where the
 * columns are.
 *
 * 1.4s linear, which is the one place the book allows linear easing alongside
 * progress bars. Reduced motion is handled globally in index.css, where the
 * shimmer is cut to its end state rather than merely slowed.
 */

// Fixed rather than random: a random width would reshuffle on every render and
// make the placeholder itself look like it was moving.
const WIDTHS = ["86%", "62%", "74%", "48%", "80%", "56%"];

const TableSkeleton = ({ columns = 4, rows = 5 }) => (
  <>
    {Array.from({ length: rows }, (_, rowIndex) => (
      <TableRow key={rowIndex}>
        {Array.from({ length: columns }, (_, colIndex) => (
          <TableCell key={colIndex}>
            {/* The bar is 12px but the cell has to occupy a real line box, or
                every row grows when the data lands and the whole table jumps.
                0.875rem x 1.6 is the body line-height a real cell renders at. */}
            <Box sx={{ height: "1.4rem", display: "flex", alignItems: "center" }}>
              <Box
                className="pl-skeleton"
                sx={{ width: WIDTHS[(rowIndex + colIndex) % WIDTHS.length] }}
              />
            </Box>
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

export default TableSkeleton;
